import { Box } from '@chakra-ui/react';
import {
  AutoSuggest,
  AutoSuggestProps,
  FieldHelpText,
  InputVariant,
} from '@pluxee-design-system/core';
import { memo, useCallback } from 'react';
import withFastField, { WithFastFieldProps } from './withFastField';

interface AutoSuggestControlProps
  extends Omit<
    AutoSuggestProps,
    'initialValue' | 'isDisabled' | 'isReadOnly' | 'name' | 'onInputChange' | 'value'
  > {
  id: string;
  name: string;
  mandatory?: boolean;
  readonly?: boolean;
  skipSuccess?: boolean;
  skipVariant?: boolean;
}

// TODO: get rid-of formik
const AutoSuggestControl = ({
  disabled,
  field,
  field: { setValue },
  id,
  name,
  readonly,
  skipSuccess = false,
  skipVariant = false,
  ...autoSuggestProps
}: AutoSuggestControlProps & WithFastFieldProps<string>) => {
  const hasError = Boolean(field.error);
  const handleInputChange = useCallback((val: string) => setValue(val, true), [setValue]);

  return (
    <Box
      sx={{
        'ul > li': {
          height: 'initial !important',
        },
      }}
    >
      <AutoSuggest
        name={name}
        id={id}
        initialValue={field.value}
        onInputChange={handleInputChange}
        variant={
          skipVariant
            ? undefined
            : readonly
              ? InputVariant.READONLY
              : field.isTouched && hasError
                ? InputVariant.ERROR
                : field.isTouched && !skipSuccess
                  ? undefined // to show X symbol (InputVariant.SUCCESS)
                  : InputVariant.FILLED
        }
        disabled={readonly ? undefined : disabled}
        onBlur={field.onBlur}
        {...autoSuggestProps}
      />
      {field.isTouched && hasError && (
        <FieldHelpText text={field.error} variant={InputVariant.ERROR} />
      )}
    </Box>
  );
};

const MemoizedAutoSuggestControl = memo(AutoSuggestControl);

export default withFastField(MemoizedAutoSuggestControl);
